import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type SOPIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const SOPIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: SOPIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='SOP'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 15 19'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.8333 12.5C11.2936 12.5 11.6667 12.8731 11.6667 13.3333C11.6667 13.7936 11.2936 14.1667 10.8333 14.1667H4.16667C3.70643 14.1667 3.33333 13.7936 3.33333 13.3333C3.33333 12.8731 3.70643 12.5 4.16667 12.5H10.8333ZM10.8333 9.16667C11.2936 9.16667 11.6667 9.53976 11.6667 10C11.6667 10.4602 11.2936 10.8333 10.8333 10.8333H4.16667C3.70643 10.8333 3.33333 10.4602 3.33333 10C3.33333 9.53976 3.70643 9.16667 4.16667 9.16667H10.8333ZM5.83333 5.83333C6.29357 5.83333 6.66667 6.20643 6.66667 6.66667C6.66667 7.1269 6.29357 7.5 5.83333 7.5H4.16667C3.70643 7.5 3.33333 7.1269 3.33333 6.66667C3.33333 6.20643 3.70643 5.83333 4.16667 5.83333H5.83333ZM10 5H12.1549L10 2.84505V5ZM15 15.8333C15 16.4964 14.7364 17.1321 14.2676 17.6009C13.7987 18.0698 13.163 18.3333 12.5 18.3333H2.5C1.83696 18.3333 1.20126 18.0698 0.732422 17.6009C0.263581 17.1321 0 16.4964 0 15.8333V2.5C0 1.83696 0.263581 1.20126 0.732422 0.732422C1.20126 0.263581 1.83696 0 2.5 0H9.16667L9.24886 0.00406901C9.43969 0.0229774 9.61907 0.107355 9.75586 0.244141L14.7559 5.24414C14.9121 5.40042 15 5.61232 15 5.83333V15.8333ZM1.66667 15.8333C1.66667 16.0543 1.75453 16.2662 1.91081 16.4225C2.06709 16.5788 2.27899 16.6667 2.5 16.6667H12.5C12.721 16.6667 12.9329 16.5788 13.0892 16.4225C13.2455 16.2662 13.3333 16.0543 13.3333 15.8333V6.66667H9.16667C8.70643 6.66667 8.33333 6.29357 8.33333 5.83333V1.66667H2.5C2.27899 1.66667 2.06709 1.75453 1.91081 1.91081C1.75453 2.06709 1.66667 2.27899 1.66667 2.5V15.8333Z'
        fill={resolvedColor}
      />
    </svg>
  )
}
